import { cmsApi } from '../../services/cmsApi';

export interface PlaylistItem {
    _id: string;
    name: string;
    description: string | null;
    total_content: number;
    totalDuration: number;
    [key: string]: any; // Allow other properties
}

export interface PlaylistResponse {
    results: PlaylistItem[];
    page: number;
    limit: number;
    totalPages: number;
    totalResults: number;
    totalResultsWithOutFilter: number;
}

export const playlistsApi = cmsApi.injectEndpoints({
    endpoints: (builder) => ({
        getSavedPlaylists: builder.query<PlaylistResponse, { page?: number; limit?: number; search?: string }>({
            query: (params) => {
                const queryParams = new URLSearchParams();
                if (params.page) queryParams.append('page', params.page.toString());
                if (params.limit) queryParams.append('limit', params.limit.toString());
                if (params.search) queryParams.append('search', params.search);
                return {
                    url: `/externalApp/v1/my-playlists?${queryParams.toString()}`,
                    method: 'GET',
                };
            },
            serializeQueryArgs: ({ queryArgs }) => {
                const { page, ...rest } = queryArgs || {};
                return rest;
            },
            merge: (currentCache, newItems) => {
                if (newItems.page === 1) return newItems;
                currentCache.results.push(...newItems.results);
                currentCache.page = newItems.page;
                return currentCache;
            },
            forceRefetch({ currentArg, previousArg }) {
                return currentArg?.page !== previousArg?.page;
            },
        }),
        getCmsPlaylists: builder.query<PlaylistResponse, { page?: number; limit?: number; search?: string }>({
            query: (params) => {
                const queryParams = new URLSearchParams();
                if (params.page) queryParams.append('page', params.page.toString());
                if (params.limit) queryParams.append('limit', params.limit.toString());
                if (params.search) queryParams.append('search', params.search);
                return {
                    url: `/externalApp/v1/my-playlists?${queryParams.toString()}`,
                    method: 'GET',
                };
            },
            serializeQueryArgs: ({ queryArgs }) => {
                const { page, ...rest } = queryArgs || {};
                return rest;
            },
            merge: (currentCache, newItems) => {
                if (newItems.page === 1) return newItems;
                currentCache.results.push(...newItems.results);
                currentCache.page = newItems.page;
                return currentCache;
            },
            forceRefetch({ currentArg, previousArg }) {
                return currentArg?.page !== previousArg?.page;
            },
        }),
    }),
});

export const { useGetSavedPlaylistsQuery, useGetCmsPlaylistsQuery } = playlistsApi;
